export const Roles = {
    Moderate: "moderate",
    Teacher: "teacher",
    Student: "user"
}
